import React, { useState, useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './DashboardPage.css';

function DashboardPage() {
  const { theme, toggleTheme } = useTheme();
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    document.title = 'PEC - Dashboard';
  }, []);

  // Mock data for metrics - you can replace with real data
  const metrics = [
    {
      title: 'Total Tareas',
      value: '156',
      change: '+12%',
      changeType: 'positive',
      icon: '✅',
      color: 'blue'
    },
    {
      title: 'Notas Creadas',
      value: '89',
      change: '+8%',
      changeType: 'positive',
      icon: '📝',
      color: 'green'
    },
    {
      title: 'Proyectos Activos',
      value: '23',
      change: '+5%',
      changeType: 'positive',
      icon: '🚀',
      color: 'purple'
    },
    {
      title: 'Eficiencia',
      value: '94%',
      change: '+2%',
      changeType: 'positive',
      icon: '📊',
      color: 'orange'
    }
  ];

  const recentActivities = [
    { id: 1, type: 'note', title: 'Nueva nota de proyecto', time: '2 min ago', icon: '📝' },
    { id: 2, type: 'task', title: 'Tarea completada: Reunión cliente', time: '15 min ago', icon: '✅' },
    { id: 3, type: 'finance', title: 'Gasto registrado: $250', time: '1 hour ago', icon: '💰' },
    { id: 4, type: 'reminder', title: 'Recordatorio: Llamada programada', time: '2 hours ago', icon: '🔔' }
  ];

  const quickActions = [
    { title: 'Nueva Nota', icon: '📝', path: '/notes', color: 'blue' },
    { title: 'Ver Finanzas', icon: '💰', path: '/finance', color: 'green' },
    { title: 'Calendario', icon: '📅', path: '/calendar', color: 'purple' },
    { title: 'Configuración', icon: '⚙️', path: '/settings', color: 'gray' }
  ];

  

  return (
    <div className="dashboard-page">
      <div className="dashboard-header">
        <div className="header-content">
          <div className="header-left">
            <h1>Dashboard</h1>
            <p>Bienvenido a tu Centro de Eficiencia Personal</p>
          </div>
          <div className="header-center">
            <div className="search-container">
              <div className="search-input-wrapper">
                <svg className="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M21 21L16.514 16.506M19 10.5A8.5 8.5 0 1110.5 2a8.5 8.5 0 018.5 8.5z" 
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <input
                  type="search"
                  placeholder="Buscar tareas, notas, proyectos..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-input"
                />
              </div>
            </div>
          </div>
          <div className="header-right">
            <button className="create-action-button">
              ➕ NUEVA TAREA
            </button>
            <button 
              onClick={toggleTheme}
              className="theme-toggle" 
              title={`Cambiar a tema ${theme === 'light' ? 'oscuro' : 'claro'}`}
            >
              {theme === 'light' ? '🌙' : '☀️'}
            </button>
          </div>
        </div>
      </div>

      <div className="dashboard-content">
        {/* Metrics Grid */}
        <div className="metrics-grid">
          {metrics.map((metric, index) => (
            <div key={index} className={`metric-card ${metric.color}`}>
              <div className="metric-header">
                <div className="metric-icon">
                  <span>{metric.icon}</span>
                </div>
                <div className={`metric-change ${metric.changeType}`}>
                  {metric.change}
                </div>
              </div>
              <div className="metric-content">
                <h3>{metric.value}</h3>
                <p>{metric.title}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="dashboard-grid">
          {/* Chart Section */}
          <div className="dashboard-card chart-card">
            <div className="card-header">
              <h3>Productividad Mensual</h3>
              <div className="card-actions">
                <button className="btn-secondary">Ver Detalles</button>
              </div>
            </div>
            <div className="chart-placeholder">
              <div className="chart-visual">
                <div className="chart-bars">
                  <div className="bar" style={{height: '60%'}}></div>
                  <div className="bar" style={{height: '80%'}}></div>
                  <div className="bar" style={{height: '45%'}}></div>
                  <div className="bar" style={{height: '90%'}}></div>
                  <div className="bar" style={{height: '70%'}}></div>
                  <div className="bar" style={{height: '85%'}}></div>
                  <div className="bar" style={{height: '95%'}}></div>
                </div>
                <div className="chart-labels">
                  <span>Ene</span>
                  <span>Feb</span>
                  <span>Mar</span>
                  <span>Abr</span>
                  <span>May</span>
                  <span>Jun</span>
                  <span>Jul</span>
                </div>
              </div>
            </div>
          </div>

          {/* Recent Activities */}
          <div className="dashboard-card activities-card">
            <div className="card-header">
              <h3>Actividades Recientes</h3>
              <a href="/updates" className="view-all">Ver Todo</a>
            </div>
            <div className="activities-list">
              {recentActivities.map((activity) => (
                <div key={activity.id} className="activity-item">
                  <div className="activity-icon">
                    <span>{activity.icon}</span>
                  </div>
                  <div className="activity-content">
                    <p>{activity.title}</p>
                    <span className="activity-time">{activity.time}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Quick Actions */}
          <div className="dashboard-card actions-card">
            <div className="card-header">
              <h3>Acciones Rápidas</h3>
            </div>
            <div className="quick-actions">
              {quickActions.map((action, index) => (
                <a key={index} href={action.path} className={`quick-action ${action.color}`}>
                  <span className="action-icon">{action.icon}</span>
                  <span className="action-title">{action.title}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Notification Card */}
          <div className="dashboard-card notification-card">
            <div className="notification-content">
              <div className="notification-badge">NUEVO</div>
              <h3>¡Funciones Mejoradas!</h3>
              <p>Hemos añadido nuevas plantillas y herramientas para mejorar tu productividad.</p>
              <button className="btn-primary">
                Explorar Ahora
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardPage; 